import { watchAuth } from "application/auth/authSaga";
import { watchChangeEmail } from "application/changeEmail/changeEmailSaga";
import { watchConfig } from "application/config/configSaga";
import { watchCustomerMe } from "application/customer/customerSaga";
import { watchDeleteAccount } from "application/deleteAccount/deleteAccountSaga";
import { watchDelivery } from "application/delivery/deliverySaga";
import { watchLocale } from "application/locale/localeSaga";
import { watchMenu } from "application/menu/menuSaga";
import { watchMerchandise } from "application/merchandise/merchandiseSaga";
import { watchOrdersMe } from "application/order/orderSaga";
import { watchReorder } from "application/reorder/reorderSaga";
import { watchProject } from "application/savedProjects/projectSaga";
import { watchStorage } from "application/storage/storageSaga";
import { watchWidget } from "application/widget/widgetSaga";
import { watchErrors } from "common/errorSaga";
import { all } from "redux-saga/effects";

export function* indexSaga() {
  return yield all([
    watchErrors(),
    watchAuth(),
    watchChangeEmail(),
    watchDeleteAccount(),
    watchConfig(),
    watchCustomerMe(),
    watchLocale(),
    watchOrdersMe(),
    watchMerchandise(),
    watchWidget(),
    watchStorage(),
    watchDelivery(),
    watchReorder(),
    watchProject(),
    watchMenu()
  ]);
}
